<template>
  <span>
    <div class="d-flex align-center">
      <label class="page-label">{{
        $t('message.pages.newLive.scheduled')
      }}</label>
    </div>

    <p
      style="font-weight: 400px; font-size: 14px; line-height: 21px"
      class="mb-3"
    >
      {{ $t('message.pages.newLive.liveScheduledTo') }}
    </p>

    <span
      style="
        font-weight: 400px;
        font-size: 16px;
        line-height: 24px;
        color: #3f55ee;
      "
    >
      {{ formattedDate }}
    </span>
  </span>
</template>

<script>
// external imports
import { isAfter, addDays, isBefore, subDays, format } from 'date-fns'

// internal imports

// API

// Components

export default {
  name: 'LiveSchedule',
  props: {
    propsData: {
      type: Object,
      required: true,
    },
    scheduled_at: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    datePickerShow: false,

    formattedDate: '',
    scheduledAtFromLive: null,
  }),
  computed: {
    // ...
  },
  methods: {
    handleClickDatePickerOutside() {
      if (this.datePickerShow) this.datePickerShow = false
    },

    handleClickSelect() {
      this.datePickerShow = true
      this.$refs.dateSelect.blur()
    },
    getAllowedDate(date_string) {
      const date = new Date(date_string)

      const date_next_month = addDays(new Date(), 31)

      const current_date = subDays(new Date(), 1)

      return isAfter(date, current_date) && isBefore(date, date_next_month)
    },
    formatDate(scheduleAt) {
      const date = new Date(scheduleAt)

      const day = ('0' + date.getDate()).slice(-2)
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const year = date.getFullYear()

      const hours = ('0' + date.getHours()).slice(-2)
      const minutes = ('0' + date.getMinutes()).slice(-2)

      this.formattedDate = `${day}/${month}/${year} - ${hours}h${minutes}`
    },
    filterHours() {
      this.datePickerShow = false

      const current_date = new Date()
      const current_hour = current_date.getHours()
      const current_minute = current_date.getMinutes()

      if (this.scheduleDate !== format(current_date, 'yyyy-MM-dd')) {
        this.hoursMinutes = this.allHoursMinutes
      } else {
        this.hoursMinutes = this.allHoursMinutes.filter((item) => {
          const [hour_string, minute_string] = item.split(':')
          const hour = parseInt(hour_string)
          const minute = parseInt(minute_string)

          const timeDifference =
            (hour - current_hour) * 60 + (minute - current_minute)
          const threshold = 10

          return timeDifference > threshold
        })
      }
    },
  },
  async mounted() {
    this.formatDate(this.scheduled_at)
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }

  &::v-deep {
    .v-icon {
      color: var(--v-brand-base);
    }
  }

  .custom-select .v-input__icon--append {
    display: none;
  }

  .datepicker-container {
    .datepicker-item {
      position: absolute;
      left: 10px;
      bottom: 10px;
      z-index: 2000;
    }
  }
}

.d-grid {
  position: relative;

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  column-gap: $spacing-plus-1;
}

.bg-dark {
  .page-label {
    color: var(--v-primary-base) !important;
  }
}
</style>
